var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPtsIcon = function SvgPtsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 17,
    fill: "none",
    viewBox: "0 0 28 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B43FF",
    d: "M0 5a5 5 0 0 1 5-5h22.625v12a5 5 0 0 1-5 5H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.184 4.647c.76 0 1.632.17 2.573.578l-.737 1.552c-.725-.34-1.269-.498-1.79-.498-.556 0-.726.192-.726.464 0 .238.148.397.601.669l1.315.827c.952.578 1.507 1.213 1.507 2.324 0 1.53-1.043 2.357-2.89 2.357a5.8 5.8 0 0 1-2.958-.793l.793-1.576c.76.465 1.508.726 2.233.726.635 0 .975-.216.975-.635 0-.363-.306-.578-.748-.85l-1.213-.76c-1.031-.611-1.462-1.37-1.462-2.266 0-1.292.85-2.12 2.527-2.12M16.964 4.817v1.598h-2.086v6.335h-1.756V6.415h-2.097V4.817zM7.974 4.817c2.006 0 2.924 1.11 2.924 2.538 0 1.553-.918 2.675-2.924 2.675H6.897v2.72H5.141V4.817zm-.147 3.626c.725 0 1.201-.351 1.201-1.054 0-.691-.476-.974-1.201-.974h-.93v2.028z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPtsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pts_icon.f3862175feeefcd857c3bf354d152dbf.svg";